import { PhoneIcon, EmailIcon, CandidateFeedbackIcon } from 'assets';
import { Button } from 'view/components';
import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme';
import {
  RecruiterStartConversationModal,
  RecruiterDenyCandidateModal,
  RecruiterApproveCandidateModal,
} from 'view/modals';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useNavigate } from 'react-router';
import { showSystemToast } from 'view/components/SystemToast';
import * as S from './styled';

const CandidateContactCard = ({ data, jobPostId = null, getJobSeekerProfileById = () => {} }) => {
  const navigate = useNavigate();
  const matches = useMediaQuery(theme.breakpoints.down('laptop'));

  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  return (
    <S.CandidateContactCard>
      {jobPostId &&
      data?.applicationStatus &&
      data?.applicationStatus?.statusForRecruiter === 'Denied' ? (
        <S.CandidateContactCardHeader
          style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
        >
          <S.CandidateContactCardHeaderTitle>
            You’ve chosen not to proceed with this candidate.
          </S.CandidateContactCardHeaderTitle>
          {data?.applicationStatus?.feedback && (
            <S.FeedbackContent>
              <S.FeedbackContentItem>
                <CandidateFeedbackIcon />
                <div>{data?.applicationStatus?.feedback}</div>
              </S.FeedbackContentItem>
            </S.FeedbackContent>
          )}
        </S.CandidateContactCardHeader>
      ) : (
        <>
          {!matches ? (
            <S.CandidateContactCardHeader>
              {jobPostId &&
              data?.applicationStatus &&
              data?.applicationStatus?.statusForRecruiter === 'Approved' ? (
                <S.CandidateContactCardHeaderTitle>
                  {'You’ve chosen to move \n forward with this \n candidate.'}
                </S.CandidateContactCardHeaderTitle>
              ) : (
                <>
                  {data?.applicationStatus &&
                  data?.applicationStatus?.statusForRecruiter === 'No status' &&
                  data?.applicationStatus?.type === 'INVITE' ? (
                    <S.CandidateContactCardHeaderTitle>
                      {'You’ve invited \n this candidate.'}
                    </S.CandidateContactCardHeaderTitle>
                  ) : (
                    <S.CandidateContactCardHeaderTitle>
                      {'Is the candidate \n the right fit for you?'}
                    </S.CandidateContactCardHeaderTitle>
                  )}
                </>
              )}

              {/* <S.CandidateContactCardHeaderStatus>Rejected</S.CandidateContactCardHeaderStatus> */}
            </S.CandidateContactCardHeader>
          ) : null}
          <S.CandidateContactCardMain>
            <S.CandidateContactCardMainItem>
              <PhoneIcon />
              <p>{data?.phone || 'No phone number'}</p>
            </S.CandidateContactCardMainItem>
            <S.CandidateContactCardMainItem>
              <EmailIcon />
              <p>{data?.email || 'No Email'}</p>
            </S.CandidateContactCardMainItem>
          </S.CandidateContactCardMain>
          {jobPostId &&
            data?.applicationStatus &&
            data?.applicationStatus?.statusForRecruiter === 'Pending' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Button
                  className="red-button"
                  variant="outlined"
                  text="Not a fit"
                  onClick={() => {
                    if (update) update({ isOpenRecruiterDenyCandidateModal: true });
                  }}
                  disabled={false}
                  style={{ width: 'max-content', flexShrink: 0, minHeight: '50px' }}
                />
                <Button
                  variant="contained"
                  text="Yes, they’re a fit"
                  onClick={() => {
                    if (update) update({ isOpenRecruiterApproveCandidateModal: true });
                  }}
                  style={{ minHeight: '50px' }}
                />
              </div>
            )}
          {jobPostId &&
            data?.applicationStatus &&
            data?.applicationStatus?.statusForRecruiter === 'Approved' && (
              <Button
                variant="contained"
                text="Go to Chat"
                onClick={() => {
                  navigate(
                    data?.applicationStatus?.chatId
                      ? `/messenger/chats?conversationId=${data?.applicationStatus?.chatId}`
                      : '/messenger/chats'
                  );
                }}
                disabled={!data?.applicationStatus?.chatId}
              />
            )}
          {jobPostId &&
            data?.applicationStatus &&
            data?.applicationStatus?.statusForRecruiter === 'No status' &&
            data?.applicationStatus?.type === 'INVITE' && (
              <Button
                variant="contained"
                text="Go to Chat"
                onClick={() => {
                  navigate(
                    data?.applicationStatus?.chatId
                      ? `/messenger/chats?conversationId=${data?.applicationStatus?.chatId}`
                      : '/messenger/chats'
                  );
                }}
                disabled={!data?.applicationStatus?.chatId}
              />
            )}
          {(!jobPostId || !data?.applicationStatus) && (
            <Button
              variant="contained"
              text="Start Conversation"
              onClick={() => {
                if (update) update({ isOpenRecruiterStartConversationModal: true });
              }}
            />
          )}
          <RecruiterStartConversationModal jobSeekerId={data?.id} />
          <RecruiterDenyCandidateModal
            applicantId={data?.applicationStatus?.id}
            successFunction={() => {
              getJobSeekerProfileById();
              showSystemToast(
                'success',
                'Feedback Sent',
                'They’ve been notified that they’re not a fit for this role.'
              );
            }}
          />
          <RecruiterApproveCandidateModal
            applicantId={data?.applicationStatus?.id}
            successFunction={() => {
              getJobSeekerProfileById();
              showSystemToast(
                'success',
                'Feedback Sent',
                'Message sent to candidate. You’ve marked them as a fit.'
              );
            }}
          />
        </>
      )}
    </S.CandidateContactCard>
  );
};

export default CandidateContactCard;
